document.querySelectorAll('[data-bb-close]').forEach(button=>button.addEventListener('click',()=>button.closest('details').removeAttribute('open')));
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape' || event.defaultPrevented) return;
  document.querySelectorAll('.bb-cat-help[open],.bb-mobile-nav[open]').forEach(details => {
    const restoreFocus = details.contains(document.activeElement);
    const summary = details.querySelector(':scope > summary');
    details.removeAttribute('open');
    if (restoreFocus) summary?.focus();
  });
});
document.querySelectorAll('[data-bb-track]').forEach(form=>form.addEventListener('submit',event=>{event.preventDefault();const number=form.querySelector('input').value.trim();if(number)window.open('https://t.17track.net/en#nums='+encodeURIComponent(number),'_blank','noopener,noreferrer');}));

// Horizon emits its cart event before the request finishes. Wait for its promise,
// then read the confirmed cart; never add an optimistic quantity to the badge.
let bbCartRefresh;
let bbCartRevision = 0;
const bbRefreshCartCount = () => {
  const revision = ++bbCartRevision;
  clearTimeout(bbCartRefresh);
  bbCartRefresh = setTimeout(async () => {
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
        credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (revision !== bbCartRevision || !Number.isInteger(cart.item_count) || cart.item_count < 0) return;
      document.querySelectorAll('[data-bb-cart-count],.bb-cart-count').forEach(el => {
        if (el.textContent !== String(cart.item_count)) el.textContent = String(cart.item_count);
      });
      bbMarkEmptyCounts();
    } catch {
      // Retain the last confirmed count when the read fails; do not repeat an add.
    }
  }, 80);
};
const bbOnCartLinesUpdate = async event => {
  ++bbCartRevision;
  clearTimeout(bbCartRefresh);
  try { await event.promise; } catch { /* The write may have arrived; read the cart. */ }
  bbRefreshCartCount();
};
// Use the same event constant as Horizon instead of guessing its wire name.
import('@shopify/events').then(({ StandardEvents }) => {
  document.addEventListener(StandardEvents.cartLinesUpdate, bbOnCartLinesUpdate);
  bbRefreshCartCount();
}).catch(() => { bbRefreshCartCount(); });
window.addEventListener('pageshow', event => { if (event.persisted) bbRefreshCartCount(); });
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') bbRefreshCartCount();
});

// Blue Hour: small, keyboard-accessible workshop interaction.
document.querySelectorAll('[data-bb-cat-note]').forEach(button=>button.addEventListener('click',()=>{const note=document.getElementById(button.getAttribute('aria-controls'));if(!note)return;const expanded=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!expanded));note.hidden=expanded;}));
const bbMarkEmptyCounts = () => document.querySelectorAll('[data-bb-cart-count],.bb-cart-count').forEach(el => {
  const count = Number(el.textContent.trim());
  el.dataset.empty = String(count === 0);
  if (!Number.isInteger(count) || count < 0) return;
  const link = el.closest('[data-bb-cart-link]');
  if (link) link.setAttribute('aria-label', `Shopping bag, ${count} ${count === 1 ? 'item' : 'items'}`);
});
bbMarkEmptyCounts();
document.querySelectorAll('[data-bb-cart-count],.bb-cart-count').forEach(el=>new MutationObserver(bbMarkEmptyCounts).observe(el,{childList:true,characterData:true,subtree:true}));
document.querySelectorAll('.bb-mobile-nav nav a').forEach(link=>link.addEventListener('click',()=>link.closest('details').removeAttribute('open')));
